<template>
  <div class="pages">
    <div class="container lunbox">
      <div class="fenlei">
        <div style="height: 10px;"></div>
        <div
          class="items"
          v-for="item in treeData"
          :key="item.cl_Na"
          @click="linkUrl(item)"
        >{{ language =="ru" ? item['threeLanguage']:language =="zh" ? item['cl_Na']:item['cl_Ne_Na'] }}</div>
        <div style="height: 10px;"></div>
      </div>
      <div class="swiper-box" v-if="swiperList.length>0">
        <swiper v-if="swiperList" :options="swiperOption">
          <swiper-slide v-for="(item, index) in swiperList" :key="index">
            <img :src="item.imgUrl" :alt="item.name" class="swiper-img" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>

    <div class="container tabNavk">
      <div :class="index == 0 ?'tabNak1':index == 1?'tabNak2':'tabNak3'" v-for="(items,index) in recommendListlist" :key="items.id">
        <img :src="items.imgUrl" alt />
      </div>
    </div>
    <div class="container">
      <div class="product-recommend">
        <div class="titilebox">
          <div class="box">
            <div class="names">{{ $t("newProduct") }}</div>
            <div class="datem">
              <div
                :class="`date-item ${actives==index ? 'date-active':''}`"
                v-for="(items,index) in dateList"
                :key="items"
                @click="options(items,index)"
              >{{ items }}</div>
            </div>
          </div>
          <div class="more" @click="raptther()">{{ $t("viewmore") }} ></div>
        </div>
        <recomm-product :datas="newProductList"></recomm-product>
      </div>
      <div class="product-recommend" v-if="hotList.length>0">
        <div class="titilebox">
          <div class="box">
            <div class="names">{{ $t("Bestproduct") }}</div>
          </div>
          <div class="more" @click="$router.push({ name:'product',params:{productType:1}})">{{ $t("viewmore") }} ></div>
        </div>
        <recomm-product :datas="hotList"></recomm-product>
      </div>
      <div class="product-recommend" v-if="recommendList.length>0">
        <div class="titilebox">
          <div class="box">
            <div class="names">{{ language =="ru" ? 'المنتجات الموصى بها':language =="zh" ? '推荐产品':'Recommended Products' }}</div>
          </div>
          <div class="more" @click="$router.push({ name:'product',params:{productType:2}})">{{ $t("viewmore") }} ></div>
        </div>
        <recomm-product :datas="recommendList"></recomm-product>
      </div>
      <div style="height: 50px;"></div>
    </div>
  </div>
</template>
<script>
import {
  CarouselGetList,
  GetProductListByDiscount,
  ProductBasicWebGetDateList,
  ProductClassRecommendWebGetList
} from '@/api/home'
import {
  getClassList,
  queryPage
} from '@/api/product'
import { mapState, mapGetters } from 'vuex'
import newProduct from '@/components/productBox/newProduct.vue'
import recommProduct from '@/components/productBox/recommProduct.vue'
import groupProduct from '@/components/productBox/groupProduct.vue'
import videoCenter from '@/components/video/videoCenter'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import transformMark from '@/utils/water'
export default {
  name: 'pageHome',
  components: {
    swiper,
    swiperSlide,
    newProduct,
    recommProduct,
    groupProduct,
    videoCenter
  },
  data() {
    return {
      actives: 0,
      dateList: [],
      hotList: [],
      treeData: [],
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true //允许分页点击跳转
        }
      },
      recommendListlist: [],
      swiperList: [],
      newProductList: [],
      recommendList: [],
      groupList: [],
      videoList: [],
      queryParam: {
        pageNo: 1,
        pageSize: 18,
        sortField: '',
        sortOrder: '',
        cl_Nu: '',
        conditionals: [],
        category: 0,
        startTime: "",
      },
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters("setting", {
      getSetting: 'get_setting'
    }),
    ...mapState('operate', ['language']),
  },
  created() {
    setTimeout(() => {
      ProductBasicWebGetDateList({
        num: 7
      }).then(res => {
        this.dateList = res.data
        this.queryParam.startTime = this.dateList[0] ? this.dateList[0] : null;
        this.initData()
      })
    }, 200);
  },
  methods: {
    raptther() {
      this.$router.push({
        name: 'product', params: {
          productType: 0,
          startTime: this.queryParam.startTime + " 00:00:00",
          endTime: this.queryParam.startTime + " 23:59:59",
        }
      })
    },
    linkUrl(item) {
      this.$router.push({ path: '/product', query: { clNu: item.cl_Nu } })
      this.$bus.$emit('categoryClick', item.cl_Nu)
    },
    options(date, index) {
      this.actives = index
      this.queryParam.startTime = date
      this.initData();
    },
    initData() {
      let _this = this
      const loading = this.$loading({
        lock: true,
        text: this.$hs('加载中...', 'Loading', 'Loading', 'جاري التحميل'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 首页轮播
      CarouselGetList().then(res => {
        if (res.success) {
          _this.swiperList = res.data
        } else {
          _this.$message.error(res.message)
        }
      }).catch(err => {
        _this.$message.error(err)
      })
      // 获取最新产品
      queryPage(this.queryParam).then(res => {
        if (res.success) {
          _this.newProductList = res.data.rows || []
          _this.newProductList.forEach(item => {
            transformMark(item.imgUrl).then(result => {
              item.imgUrl = result
            })
          })
        } else {
          _this.$message.error(res.message)
        }
      }).catch(err => {
        _this.$message.error(err)
      })

      // 热销产品
      GetProductListByDiscount({
        client_Nu: _this.userInfo.client_Nu || '',
        num: 6,
        category: 1
      }).then(res => {
        if (res.success) {
          _this.hotList = res.data || []
          _this.hotList.forEach(item => {
            transformMark(item.imgUrl).then(result => {
              item.imgUrl = result
            })
          })
        } else {
          _this.$message.error(res.message)
        }
      }).catch(err => {
        _this.$message.error(err)
      })

      // 推荐产品
      GetProductListByDiscount({
        client_Nu: _this.userInfo.client_Nu || '',
        number: 12,
        category: 0
      }).then(res => {
        if (res.success) {
          _this.recommendList = res.data || []
          _this.recommendList.forEach(item => {
            transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(result => {
              item.imgUrl = result
            })
          })
        } else {
          _this.$message.error(res.message)
        }
      }).catch(err => {
        _this.$message.error(err)
      })

      getClassList().then(res => {
        if (res.success) {
          this.treeData = res.data
        }
      })
      ProductClassRecommendWebGetList({ num: 3 }).then(res => {
        if (res.success) {
          this.recommendListlist = res.data
        }
      })
      loading.close();
    }
  }
}
</script>

<style lang="scss" scoped>
.pages {
  background: linear-gradient(135deg, #aee7fb, #fadbea 51%, #f9e1cf);
  padding-top: 30px;
}
.lunbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .fenlei {
    width: 240px;
    max-height: 450px;
    min-height: 450px;
    overflow-y: scroll;
    background: linear-gradient(180deg, #fe6896, #fd9f66 43%, #fcde5a);
    border-radius: 12px;
    .items {
      height: 40px;
      line-height: 40px;
      margin-left: 30px;
      width: 80%;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
      -o-text-overflow: ellipsis;
    }
    .items:hover {
      color: #d871b8;
    }
  }

  /* 自定义滚动条 */
  .fenlei::-webkit-scrollbar {
    width: 6px; /* 滚动条宽度 */
  }

  .fenlei::-webkit-scrollbar-track {
    background: transparent; /* 透明轨道 */
    border-radius: 3px;
  }

  .fenlei::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3); /* 半透明滑块 */
    border-radius: 3px;
  }

  .fenlei::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5); /* 悬停时稍亮 */
  }
  .swiper-box {
    width: 1180px;
    height: 450px;
    & .swiper-img {
      width: 1180px;
      height: 450px;
    }

    & :deep(.swiper-pagination-bullet-active) {
      background-color: #9fe7ff;
    }
  }
}
.tabNavk {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  > div {
    width: 460px;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    background: #feffff;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 460px;
      max-height: 200px;
    }
  }
}
.titilebox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 23px;
  margin-top: 53px;
  .box {
    display: flex;
    align-items: center;
    .names {
      font-size: 26px;
      font-weight: 700;
      text-align: left;
      color: #383e44;
    }
    .datem {
      margin-left: 40px;
      display: flex;
      .date-item {
        width: 96px;
        height: 32px;
        background: #ffffff;
        border-radius: 16px;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        line-height: 32px;
        margin-right: 16px;
        cursor: pointer;
      }
      .date-active {
        color: #fff;
        background: #d871b8;
      }
      .date-item:hover {
        color: #fff;
        background: #d871b8;
      }
    }
  }

  .more {
    width: 96px;
    height: 32px;
    line-height: 32px;
    background: #fffbf4;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 400;
    color: #111111;
    text-align: center;
    cursor: pointer;
  }
}
</style>